import React from 'react';
import PropTypes from 'prop-types';
import { wrapFunctionalComponent } from 'utils/framework';
import { Text } from 'components/ui';
import Icon from 'components/Icon';
import { colors } from 'style/config';

/** Renders a red X badge with "Out of Stock" label for a fulfillment slot in the Pickup & Delivery zone. */
const OutOfStock = ({ getText }) => (
    <Text
        lineHeight={'none'}
        fontSize='sm'
        fontWeight='bold'
        color={colors.red}
    >
        <Icon
            name='xBold'
            size={16}
            marginRight={2}
        />
        {getText('outOfStock')}
    </Text>
);

OutOfStock.propTypes = { getText: PropTypes.func.isRequired };

export default wrapFunctionalComponent(OutOfStock, 'OutOfStock');
